export default {
  "content": "<title>Information</title><path d=\"M196 220h64v172M187 396h138\" class=\"ionicon-fill-none\"/><path d=\"M256 160a32 32 0 1132-32 32 32 0 01-32 32z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};